/* BalkanTuning Premium – поведение за секциите bt-* */
(function () {
  function init(root) {
    root = root || document;

    /* появяване при скрол */
    var items = root.querySelectorAll('.bt-rv:not(.is-in)');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px' });
      items.forEach(function (el) { io.observe(el); });
    } else { items.forEach(function (el) { el.classList.add('is-in'); }); }

    /* табове с продукти */
    root.querySelectorAll('[data-bt-tabs]').forEach(function (wrap) {
      if (wrap.dataset.btReady) return; wrap.dataset.btReady = '1';
      var btns = wrap.querySelectorAll('[role="tab"]');
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          btns.forEach(function (x) {
            var on = x === b; x.setAttribute('aria-selected', on);
            var p = document.getElementById(x.getAttribute('aria-controls')); if (p) p.hidden = !on;
          });
        });
      });
    });

    /* обратно броене */
    root.querySelectorAll('[data-bt-countdown]').forEach(function (el) {
      if (el.dataset.btReady) return; el.dataset.btReady = '1';
      var end = Date.parse((el.dataset.btCountdown || '').replace(' ', 'T'));
      if (isNaN(end)) { el.hidden = true; return; }
      var b = el.querySelectorAll('b');
      function tick() {
        var left = end - Date.now();
        if (left <= 0) { el.hidden = true; clearInterval(t); return; }
        var v = [Math.floor(left / 864e5), Math.floor(left % 864e5 / 36e5), Math.floor(left % 36e5 / 6e4), Math.floor(left % 6e4 / 1e3)];
        b.forEach(function (x, i) { x.textContent = String(v[i]).padStart(2, '0'); });
      }
      el.hidden = false; tick(); var t = setInterval(tick, 1000);
    });

    /* SEO текст */
    root.querySelectorAll('[data-bt-seo-toggle]').forEach(function (btn) {
      if (btn.dataset.btReady) return; btn.dataset.btReady = '1';
      btn.addEventListener('click', function () {
        var s = btn.closest('.bt-seo'); var open = s.classList.toggle('is-open');
        btn.textContent = open ? btn.dataset.less : btn.dataset.more; btn.setAttribute('aria-expanded', open);
      });
    });
  }

  /* добавяне в количката (отваря cart drawer на темата, ако го има) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bt-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    btn.disabled = true;
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: Number(btn.dataset.btAdd), quantity: 1 }] };
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || 'error');
        var cartUrl = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
        if (drawer && drawer.renderContents && res.j.sections) {
          try {
            var item = res.j.items && res.j.items[0];
            drawer.classList.remove('is-empty');
            drawer.renderContents(Object.assign({}, res.j, { id: item ? item.variant_id : btn.dataset.btAdd }));
          } catch (x) { window.location.href = cartUrl; }
        } else { window.location.href = cartUrl; }
      })
      .catch(function (err) { alert(err.message === 'error' ? 'Продуктът не можа да бъде добавен.' : err.message); })
      .finally(function () { btn.disabled = false; });
  });

  /* 3rd party чекаут (co.middleware.bg): middleware замества бутона за плащане със собствен (.mw-btn-modal).
     1) Middleware зарежда настройките си веднъж при отваряне на страницата. Ако се кликне преди това
        (първа сесия, бавен мобилен интернет), той сам пренасочва към стандартния чекаут на Shopify.
        Затова задържаме клика, докато настройките дойдат (window.btMw от header-logo.liquid), до 15 s.
     2) След всяко прерисуване на количката за кратко се вижда стандартният бутон на Shopify –
        кликът по него се пренасочва към бутона на middleware. */
  function mwActive() { return !!(window.mw_key || document.querySelector('script[src*="co.middleware.bg"]')); }
  function mwReady() {
    var st = window.btMw;
    if (st && (st.ready || st.failed)) return true;
    if (st && st.seen) return false;
    // следенето е включено след заявката на middleware – гледаме дали всички co.php заявки са приключили
    var req = performance.getEntriesByType('resource').filter(function (r) { return /middleware\.bg\/shopify\/co\/co\.php/.test(r.name); });
    return req.length > 0 && req.every(function (r) { return r.responseEnd > 0; });
  }
  function mwButton() { return document.querySelector('cart-drawer .mw-btn-modal') || document.querySelector('.mw-btn-modal'); }
  var mwWaiting = false;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.mw-btn-modal, #CartDrawer-Checkout, .cart__checkout-button, button[name="checkout"]');
    if (!btn || !mwActive()) return;
    if (btn.dataset.btMwPass) { delete btn.dataset.btMwPass; return; }
    var isMw = btn.classList.contains('mw-btn-modal');
    if (isMw && mwReady()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (mwWaiting) return;
    mwWaiting = true;
    btn.classList.add(isMw ? 'bt-mw-wait' : 'loading');
    var started = Date.now();
    (function go() {
      var mw = mwButton();
      var timeout = Date.now() - started > 15000;
      if ((mw && mwReady()) || timeout) {
        mwWaiting = false;
        btn.classList.remove('loading', 'bt-mw-wait');
        var target = mw || btn; // без бутон на middleware след 15 s – стандартният чекаут като резерва
        target.dataset.btMwPass = '1';
        target.click();
        return;
      }
      setTimeout(go, 100);
    })();
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
